import { useQuery } from "react-query";
import { getPLAccount } from "./getPLAccount";

export function usePersonalLoanAccount({
  accountId,
  enabled,
  initialData,
  initialStale,
}) {
  const accountInfo = useQuery(
    ["account", { accountId }],
    () => getPLAccount(accountId),
    {
      ...(enabled === undefined ? {} : { enabled }),
      ...(initialData === undefined ? {} : { initialData }),
      ...(initialStale === undefined ? {} : { initialStale }),
    },
  );

  return accountInfo;
}
